import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header, Footer } from "../../../components";
import Sidebar from "../../../components/Common/Sidebar";
import SidebarNew from "../../../components/Common/SidebarNew";
import { getItem } from "../../../utils/localStorageUtils";
import SidebarBs from "../../../components/Common/SidebarBs";

const InnerMainLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  return (
    <div className={`theme-default h-full flex overflow-clip`}>
      <div
        className={`${
          isCollapsed ? "w-20" : "w-64"
        } transition-all duration-500 flex-shrink-0 `}
      >
        {getItem("portal") === "wf" ? (
          <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
        ) : // ) : localStorage.getItem("portal") === "ats" ? (
        getItem("portal") === "ats" ? (
          // <SidebarMenuItems items={atsNavLinkData} isCollapsed={isCollapsed} />
          <SidebarNew
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
          />
        ) : getItem("portal") === "bs" ? (
          <SidebarBs
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
          />
        ) : null}
      </div>

      <div
        className="flex-1  transition-all duration-500 flex flex-col overflow-hidden"
        style={{
          width: isCollapsed ? "calc(100% - 80px)" : "calc(100% - 256px)",
        }}
      >
        <Header />
        <div className="ml-2 pr-2 py-2 flex flex-1  flex-col overflow-auto">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default InnerMainLayout;
